import React, { useContext, useEffect, useState, FC } from 'react';
import { Button } from '../../../../shared/button';
import { Share, Dollar } from '../../../../shared/icons';
import { Label } from '../../../../shared/typefaces/Typefaces.styles';
import { Header, Content, Card } from '../../../../shared/card';
import { LayoutContext } from '../../../../../contexts/layoutContext';
import { theme } from '../../../../../styles/theme';
import BrandItem from './brandItem/BrandItem';

import { Table, Col, HeaderRow } from './Brands.styles';
import { LayoutColumn } from '../../../../shared/layout';
import { useFormContext } from 'react-hook-form';
import { isEmpty } from '../../../../../utils/helper';
import { IBrandsProps } from './brands.types';
import { overlayConstants } from '../../../../shared/layout/layoutOverlay/constants';
import { checkIfAccountIsNotComplete } from '../../../../../utils/helper/account';

export const Brands: FC<IBrandsProps> = ({ ingredient, setIngredientData }) => {
  const { appWidth, account, user, dispatch } = useContext(LayoutContext);
  const [selectedSupplierBrands, setSelectedSupplierBrands] = useState([]);
  const [prevSelectedSupplier, setPrevSelectedSupplier] = useState('');

  const { errors, watch } = useFormContext();

  useEffect(() => {
    const selectedSupplier = watch('supplier');
    if (selectedSupplier && selectedSupplier !== prevSelectedSupplier) {
      const brandSuppliers = ingredient?.data?.ingredient.ingredient?.ingredientProducts.filter(
        (product) => {
          return product.supplierId === selectedSupplier;
        }
      );
      const brands = [];
      if (brandSuppliers) {
        for (const product of brandSuppliers) {
          if (product.brandId && !brands[product.brandId]) {
            brands[product.brandId] = {
              ...product,
            };
          }
        }
      }
      if (!isEmpty(brands)) {
        setSelectedSupplierBrands(brands);
      }
      setPrevSelectedSupplier(selectedSupplier);
    }
  }, [ingredient, selectedSupplierBrands, prevSelectedSupplier, watch]);

  const handleAddBrand = () => {
    setIngredientData();
    dispatch({ type: 'SELECT_BRAND', payload: '' });
    dispatch({ type: 'SELECT_SUPPLIER', payload: '' });
    dispatch({ type: 'SET_BRAND_USER_EVENT', payload: 'add' });
    if (checkIfAccountIsNotComplete(user?.email, account?.type)) {
      dispatch({
        type: 'SET_OVERLAY',
        payload: overlayConstants.noAccountSaveBrand,
      });
    }
    dispatch({ type: 'TOP_SLIDER_PAGE', payload: 'brand' });
  };

  const getTableHeader = () => {
    if (appWidth !== 0 && appWidth < theme.mQ.mobileM) {
      return (
        <HeaderRow>
          <Col>
            <Label>Brand</Label>
          </Col>
          <Col>
            <LayoutColumn>
              <Label>Avg Cost:</Label>
              <Label color="grey">100 Grams</Label>
            </LayoutColumn>
          </Col>
        </HeaderRow>
      );
    } else if (appWidth !== 0 && appWidth < theme.mQ.mobileL) {
      return (
        <HeaderRow>
          <Col>
            <Label>Brand</Label>
          </Col>
          <Col>
            <LayoutColumn>
              <Label>Avg Cost:</Label>
              <Label color="grey">100 Grams</Label>
            </LayoutColumn>
          </Col>
        </HeaderRow>
      );
    } else {
      return (
        <HeaderRow>
          <Col>
            <Label>Brand</Label>
          </Col>
          <Col>
            <LayoutColumn>
              <Label>Avg Cost:</Label>
              <Label color="grey">100 Grams</Label>
            </LayoutColumn>
          </Col>
        </HeaderRow>
      );
    }
  };

  if (ingredient?.loading) {
    return null;
  }

  const ingredientProductsMap: Record<string, any> = {};

  if (!isEmpty(ingredient?.data!.ingredient!.ingredient)) {
    for (const product of ingredient!.data!.ingredient!.ingredient!
      .ingredientProducts) {
      const key = product.brandId;
      if (key) {
        const existingBrand = ingredientProductsMap[key];
        if (existingBrand && ingredientProductsMap[key].size) {
          ingredientProductsMap[key] = {
            ...existingBrand,
            size: {
              productCost:
                (ingredientProductsMap[key].size.productCost *
                  (ingredientProductsMap[key].size.count +
                    (product.size!.productCost / product.size!.productGrams) *
                      100)) /
                (ingredientProductsMap[key].size.count + 1),
              count: ingredientProductsMap[key].size.count + 1,
            },
          };
        } else {
          ingredientProductsMap[key] = {
            supplierId: product.supplierId,
            brandId: product.brandId,
            brand: product.brand,
            size: product.size
              ? {
                  productCost:
                    (product.size!.productCost / product.size!.productGrams) *
                    100,
                  productGrams: 100,
                  count: 1,
                }
              : undefined,
          };
        }
      }
    }
  }

  return (
    <Card withCardLink>
      <Header
        icon={<Dollar size="small" />}
        heading={
          appWidth !== 0 && appWidth < theme.mQ.tablet
            ? `Add ${ingredient?.data?.ingredient?.ingredient?.displayName}  Brand`
            : `${ingredient?.data?.ingredient?.ingredient?.displayName} Brands`
        }
        subHeading="Compare average prices chefs have previously paid for brands"
        errorText={errors.brand && errors.brand.message}
        button={
          appWidth !== 0 && appWidth < theme.mQ.tablet ? (
            <Button color="primary" asCircle onClick={handleAddBrand}>
              <Share color="white" size="small" />
            </Button>
          ) : (
            <Button color="primary" onClick={handleAddBrand}>
              Add Brand
            </Button>
          )
        }
      />
      <Content fullWidth>
        <Table>
          {!isEmpty(ingredientProductsMap) && getTableHeader()}
          {Object.values(ingredientProductsMap)?.map((product, idx) => {
            return (
              <BrandItem
                col={product}
                key={idx}
                selectedSupplierBrands={Object.keys(selectedSupplierBrands)}
                setIngredientData={setIngredientData}
              />
            );
          })}
        </Table>
      </Content>
    </Card>
  );
};

export default Brands;
